import { useLayoutEffect } from "react";
import { canCopyDetails } from "../utils/roles";

// Listen on document so MUI dialogs and other portals follow the same policy.
export default function useClipboardGuard(auth) {
  const restricted = Boolean(auth) && !canCopyDetails(auth.role);

  useLayoutEffect(() => {
    if (!restricted) return;

    const block = (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
    };
    const blockDrag = (event) => {
      if (event.target.closest?.("input, textarea, [contenteditable='true'], [contenteditable='']")) return;
      block(event);
    };

    document.body.classList.add("clipboard-restricted");
    document.addEventListener("copy", block, true);
    document.addEventListener("cut", block, true);
    document.addEventListener("dragstart", blockDrag, true);

    return () => {
      document.body.classList.remove("clipboard-restricted");
      document.removeEventListener("copy", block, true);
      document.removeEventListener("cut", block, true);
      document.removeEventListener("dragstart", blockDrag, true);
    };
  }, [restricted]);
}
